import { __assign, __spreadArrays } from "tslib";
import { getAdContext } from 'shared/utils/adContext';
var URL_REGEX = new RegExp('^https?:\\/\\/');
/**
 * Returns the provided string as-is if it is a
 * valid URL. Returns undefined if it is not.
 */
export var validUrlOrUndefined = function (possibleUrl) {
    return possibleUrl && URL_REGEX.test(possibleUrl) ? possibleUrl : undefined;
};
/**
 * Replace all mustache macros (ie. `{{dsp_name}}`) in a string.
 */
export var replaceMacros = function (input) {
    var context = getAdContext();
    var mustacheRegex = /{{([^}]+)}}/g;
    var replacer = function (_, macro) {
        return encodeURIComponent(context[macro] || '');
    };
    return (input
        // `{{context}}` can be used to include all relevant tracking data.
        .replace(/{{context}}/g, function () {
        return 'app_name=adapt&app_id={{app_id}}&adapt_id={{deliverable_id}}&cb={{o}}&dsp_advertiser={{dsp_advertiser}}' +
            '&dsp_campaign={{dsp_campaign}}&dsp_creative={{dsp_creative}}&dsp_name={{dsp_name}}&dsp_line={{dsp_line}}' +
            '&g={{geo}}&order_mgmt_id={{order_mgmt_id}}&order_mgmt_name={{order_mgmt_name}}' +
            '&orientation={{orientation}}&platform={{platform}}&size={{size}}&site={{site}}';
    })
        // Replace other possible matches.
        .replace(mustacheRegex, replacer));
};
export function parseQueryString(urlOrSearchString, singleValuesOnly) {
    var queryString = '';
    if (/^(https?|file):/.test(urlOrSearchString) ||
        urlOrSearchString.indexOf('?') === 0) {
        queryString = urlOrSearchString.split('?')[1] || '';
    }
    else {
        queryString = urlOrSearchString;
    }
    try {
        // Get all non-empty query parameter pairs.
        var pairs = queryString.split('&').filter(Boolean);
        return pairs.reduce(function (carrier, pair) {
            var _a, _b;
            var split = pair.split('=');
            var key = decodeURIComponent(split[0].replace(/\+/g, ' '));
            var value;
            try {
                value =
                    split.length > 1
                        ? decodeURIComponent(split[1].replace(/\+/g, ' ') || '')
                        : '';
            }
            catch (_) {
                value = split[1] || '';
            }
            var existingValue = carrier[key];
            if (existingValue === undefined) {
                // If there is not an existing value
                // for this key, we use this new one.
                return __assign(__assign({}, carrier), (_a = {}, _a[key] = value, _a));
            }
            else if (singleValuesOnly) {
                // If there is an existing value and we don't support
                // array values, throw away any new value.
                return carrier;
            }
            else {
                // If there is an existing value and we support array values,
                // combine the existing value(s) and the new value.
                return __assign(__assign({}, carrier), (_b = {}, _b[key] = Array.isArray(existingValue)
                    ? __spreadArrays(existingValue, [value]) : [existingValue, value], _b));
            }
        }, {});
    }
    catch (e) {
        // We don't want to halt Adapt if given a invalid user-submitted URL.
        return {};
    }
}
